import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { RequirementAggregate } from '~/schema';
import { State } from '~/types';
import capitalize from '~/utils/string';
import StatusBadge from '~/components/audit/status-badge.component';
import { REQUIREMENT_STATUS_STATE_MAP } from '~/constants';
import useCompanyContext from '~/hooks/company-scope.hook';

interface RequirementStatusAggregationProps {
  items: Array<Partial<RequirementAggregate>>;
  className?: string;
}

const RequirementStatusAggregation = ({
  items,
  className,
}: RequirementStatusAggregationProps) => {
  const { t } = useTranslation();
  const { isPremium } = useCompanyContext();
  return (
    <div className={classNames('c-card', className)}>
      <p className="c-label">
        {isPremium ? t('compliance') : t('Van toepassing')}
      </p>
      <div className="grid grid-cols-2 gap-2">
        {items
          .filter(({ status }) => status !== null)
          .map((item) => (
            <StatusBadge
              key={`${item?.status}-${item?.count}`}
              count={item?.count}
              status={
                item.status === null
                  ? capitalize(t('nog geen status'))
                  : t(item.status)
              }
              state={
                REQUIREMENT_STATUS_STATE_MAP[item.status || ''] || State.Default
              }
            />
          ))}
      </div>
    </div>
  );
};

export default RequirementStatusAggregation;
